export default {
    baseStyle: {
        container: {
            backgroundColor: 'gray.100',
            borderRadius: 'base',
            sx: {
                '.donation-confirmation-message p': {
                    display: 'inline'
                }
            }
        },
        checkboxRow: {
            background: 'gray.100',
            display: 'flex',
            alignItems: 'center'
        },
        roundUpContainer: {
            background: 'gray.100',
            margin: {base: '20px 0 0 0', lg: '15px 0 0 92px'}
        },
        roundUpButtonWrapper: {
            display: 'flex',
            gap: '20px',
            marginTop: '10px'
        },
        roundUpButton: {
            borderRadius: '3px',
            backgroundColor: 'gray.400',
            color: 'black.100',
            padding: '10px 18px',
            fontWeight: '300',
            fontSize: '16px',
            border: 'none',
            _hover: {
                backgroundColor: 'gray.400'
            }
        },
        roundUpButtonActive: {
            backgroundColor: 'black.100',
            color: 'white',
            _hover: {
                backgroundColor: 'blac.100'
            }
        },
        supersizeHeader: {
            fontFamily: 'body',
            color: 'black.100',
            fontSize: '14px',
            fontWeight: '400',
            lineHeight: '22px',
            letterSpacing: '0.07px'
        },
        checkbox: {
            fontFamily: 'inter'
        },
        label: {
            fontFamily: 'inter',
            fontWeight: 300,
            fontSize: '14px',
            color: 'black.300'
        },
        amountText: {
            fontWeight: 600
        },
        subMessage: {
            fontFamily: 'inter',
            fontWeight: 300,
            fontSize: '12px',
            color: 'gray.600',
            marginTop: 1,
            paddingLeft: 6
        },
        donationLabel: {
            background: 'gray.100',
            flexDirection: 'row',
            gap: '15px'
        },
        donationLabelWrapper: {
            gap: '5px'
        },
        donationTitle: {
            color: 'black.100',
            fontFamily: 'body',
            fontSize: '16px',
            fontWeight: '400',
            lineHeight: '25px',
            letterSpacing: '0.08px'
        },
        donationSubTitle: {
            color: 'black.100',
            fontFamily: 'body',
            fontSize: '13px',
            fontWeight: '300',
            lineHeight: '22px',
            letterSpacing: '0.065px'
        }
    }
}
